import { motion } from "framer-motion";
import { Media } from "@/components/Media";

const EASE = [0.16, 1, 0.3, 1];

const SHOTS = [
  {
    video: "/media/lifestyle-1.mp4",
    poster: "/media/lifestyle-1.png",
    caption: "Walk out smiling — report in hand",
    testid: "lifestyle-walkout",
  },
  {
    video: "/media/lifestyle-2.mp4",
    poster: "/media/lifestyle-2.png",
    caption: "Walk in — no appointment needed",
    testid: "lifestyle-walkin",
  },
];

export const LifestyleStrip = () => (
  <section className="py-28 lg:py-36 px-6 sm:px-12 max-w-7xl mx-auto" data-testid="lifestyle-section">
    <motion.h2
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: EASE }}
      className="font-display font-semibold tracking-tight text-center text-[#3A3A3C] text-3xl sm:text-4xl leading-[1.15]"
    >
      Care people actually walk toward.
    </motion.h2>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16">
      {SHOTS.map((s, i) => (
        <motion.figure
          key={s.testid}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.1, ease: EASE, delay: i * 0.15 }}
          className={`relative rounded-[2rem] overflow-hidden aspect-[4/3] group ${i === 1 ? "md:mt-16" : ""}`}
          data-testid={s.testid}
        >
          <Media
            video={s.video}
            poster={s.poster}
            alt={s.caption}
            kenburns
            testid={`${s.testid}-media`}
          />
          <figcaption className="absolute bottom-5 left-5 z-10 backdrop-blur-md bg-white/70 border border-white/40 rounded-full px-4 py-2 text-xs font-medium text-[#3A3A3C]">
            {s.caption}
          </figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
);
